import React, { useState } from 'react';
import './../../entrydoor.css';

const TransomOption = ({ value, label = 'Option' }) => {
    const [selectedTransomOption, setSelectedTransomOption] = useState(value || "");

    const handleTransomOptionChange = (e) => {
        setSelectedTransomOption(e.target.value);
    };

    return (
        <div className="a-container">
            <label  style={{ display: "none" }} htmlFor="TransomOption">{label}</label>
            <select style={{ display: "none" }}
                id="TransomOption"
                value={selectedTransomOption}
                onChange={handleTransomOptionChange}
            >
            <option value="" disabled hidden>Select an option</option>    
            <option value="None">{setSelectedTransomOption === "None" ? "None ✔" : "None"}</option>
            <option value="Clear">{setSelectedTransomOption === "Clear" ? "Clear ✔" : "Clear"}</option>
            <option value="Sandblasted">{setSelectedTransomOption === "Sandblasted" ? "Sandblasted ✔" : "Sandblasted"}</option>
            <option value="Screen">{setSelectedTransomOption === "Screen" ? "Screen ✔" : "Screen"}</option>
            <option value="RainNiagara">{setSelectedTransomOption === "RainNiagara" ? "Rain/Niagara ✔" : "Rain/Niagara"}</option>
            <option value="MistLite">{setSelectedTransomOption === "MistLite" ? "Mist Lite ✔" : "Mist Lite"}</option>
            <option value="Cutout">{setSelectedTransomOption === "Cutout" ? "Cutout ✔" : "Cutout"}</option>
            <option value="DealerSuppliedGlassLites">{setSelectedTransomOption === "DealerSuppliedGlassLites" ? 
            "Dealer Supplied Glass Lites ✔" : "Dealer Supplied Glass Lites"}</option>
            </select>
        </div>
    );
};

export default TransomOption;
